import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__';
import { meQuery } from '@/routes/_app/loader';

const AcceptTermsOfService = gql(`
  mutation AcceptTermsOfService {
    acceptTermsOfService {
      id
      acceptedTermsOfService
    }
  }
`);

export const useAcceptTermsOfService = () => {
  const toast = useToast();
  const [mutate, result] = useMutation(AcceptTermsOfService, {
    onError(error) {
      toast.error({
        title: 'Failed to accept terms of service',
        subTitle: error?.message || 'Please try again',
      });
    },

    update(cache, { data }) {
      if (data?.acceptTermsOfService) {
        const existingMeData = cache.readQuery({
          query: meQuery,
        });

        if (existingMeData?.me) {
          cache.writeQuery({
            query: meQuery,
            data: {
              me: {
                ...existingMeData.me,
                acceptedTermsOfService:
                  data.acceptTermsOfService.acceptedTermsOfService,
              },
            },
          });
        }
      }
    },
  });

  const acceptTermsOfService = () => {
    return mutate({
      optimisticResponse: {
        acceptTermsOfService: {
          __typename: 'User',
          id: '',
          acceptedTermsOfService: true,
        },
      },
    });
  };

  return [acceptTermsOfService, result] as const;
};
